import {Pipe, PipeTransform} from '@angular/core';
import {Observable} from "rxjs";
import {map, startWith, switchMap} from "rxjs/operators";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {GlobalVariablesService} from "../service/global-variables.service";

@Pipe({
    name: 'customSensorDataTraduction$',
    standalone: true
})
export class CustomSensorDataTraductionPipe implements PipeTransform {
    constructor(private translateService: TranslateService,
                private globalVariableService: GlobalVariablesService) {

    }

    transform(key: string | undefined): Observable<string | undefined> {
        return this.globalVariableService.customSensorData$.pipe(
            map(sensorDataType => {
                return {sensorDataType}
            }),
            map(({sensorDataType}) => {
                return this.globalVariableService.getCustomSensorDataTypeTraduction(sensorDataType, key);
            })
        )
    }

}
